import React, { useState, useReducer, useEffect } from "react";
import axios from "axios";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";
import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";
import { selectisAuthenticated } from "../../../features/auth/authSlice";
import { useSelector } from "react-redux";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { Button, Icon, Grid } from "semantic-ui-react";
import { server } from "../../../App";
import { columnDefs, defaultColDef } from "./GridParams/GridParams";
// import { useForm } from "react-hook-form";
// import moment from "moment";

import CourrierHistoric from "./CourrierHistoric";
import Cert from "./cert";
import CertHistoric from "./certHistoric";
import Note from "./Note";
import NOTE3COLUMNS_ACTE_REALISE from "./Note3columns_Acte_Realise";
import NOTE3COLUMNS_ACTE_PROPOSE from "./Note3columns_Acte_Propose";
import NOTE3COLUMNS_ANGIO from "./Note3columns_ANGIO";
import NOTE3COLUMNS_FO from "./Note3columns_FO";
import NOTE3COLUMNS_LAF from "./Note3columns_LAF";
import NOTE3COLUMNS_OCT from "./Note3columns_OCT";
import NOTE1COLUMN_AV_SC from "./Note1column_AV_SC";
import NOTE1COLUMN_MOTIF_CS from "./Note1column_MOTIF_CS";
import NOTE1COLUMN_PIO from "./Note1column_PIO";
import NOTE1COLUMN_CO_PORTEE from "./Note1column_CO_PORTEE";
import NOTE1COLUMN_CO_PORTEE_FINALE from "./Note1column_CO_PORTEE_FINALE";
import NewExamensComplementaire from "./NewExamensComplementaire";
import HistoricNewExamensComplementaire from "./HistoricNewExamensComplementaire";
import ModalPDF from "./ModalPDF";
import Medicaments from "./Medicaments";
import MedicamentsHistoric from "./MedicamentsHistoric";
import Courrier2 from "./Courrier2";
import Migration from "./Migration";
import { useWindowSize } from "react-use";

function Bloc3(props) {
  // APP state
  const [state, dispatch] = useReducer(reducer, initialState);
  // const { register, handleSubmit } = useForm({ mode: "onChange" });
  // const { getAccessTokenSilently, user } = useAuth0();
  const PatientelleState = useSelector(selectPatientelleGrid);
  const AuthState = useSelector(selectisAuthenticated);
  // ag grid state
  const [gridApi, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);

  const { width, height } = useWindowSize();
  const [NewHeightValue, setNewHeightValue] = useState("calc(83vh - 52px)");
  const { questionnaireData, userInformation } = props;

  let ID = PatientelleState.idpatient;

  async function getOneUser() {
    await axios
      .get(`${server}Consultation/${PatientelleState.idpatient}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch({ type: "FETCH_SUCCESS", payload: response.data });
        // getDossierData(response.data)
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }
  async function deleteOneExamen() {
    await axios
      .delete(
        `${server}Consultation/${state.id_consultation}/${PatientelleState.idpatient}/${state.DateConsultation}/${state.fk_id_examen}`,
        {
          headers: {
            jwtoken: sessionStorage.token,
          },
        }
      )
      .then((response) => {
        dispatch({ type: "FETCH_SUCCESS", payload: response.data });
      })
      .then(() => {
        const emptyCheckbox = {
          clientArray: {
            DateConsultation: "",
            created_at: "",
            created_by: "",
            fk_id_examen: "",
            fk_id_patientConsul: "",
            id_consultation: "",
            nom_examen: "",
            observation: "",
            od: "",
            og: "",
            updated_at: "",
            updated_by: "",
          },
        };
        dispatch({
          type: ACTION.FORM_LOAD_CONSULTATION,
          value: emptyCheckbox,
        });
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }

  useEffect(() => {
    getOneUser();
  }, []);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    gridApi?.resetRowHeights();
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        clientArray: {
          DateConsultation: "",
          created_at: "",
          created_by: "",
          fk_id_examen: "",
          fk_id_patientConsul: "",
          id_consultation: "",
          nom_examen: "",
          observation: "",
          od: "",
          og: "",
          updated_at: "",
          updated_by: "",
        },
      };
      dispatch({
        type: ACTION.FORM_LOAD_CONSULTATION,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];
      let obj = { clientArray };

      dispatch({
        type: ACTION.FORM_LOAD_CONSULTATION,
        value: obj,
      });
    }
  };

  const onCellValueChanged = async ({ data }) => {
    const ValuesToUpdate = { ...data, updated_by: AuthState.user_name };

    axios({
      method: "put",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToUpdate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        dispatch({
          type: ACTION.UPDATE_SUCCESS_CONSULTATION,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const syncData = (data) => {
    dispatch({ type: ACTION.UPDATE_SUCCESS_CONSULTATION, payload: data });
  };

  function name(height, width) {
    if (height <= 768) {
      setNewHeightValue("calc(90vh - 52px)");
    } else {
      setNewHeightValue("calc(83vh - 52px)");
    }
  }
  useEffect(() => {
    name(height, width);
  }, [height, width]);

  const myfunc = (params) => {
    // console.log(params.data.od);
    let newlines = 0;
    let words = 0;
    if (params.data.od) {
      words = params.data.od;
    } else {
      words = [];
    }
    words = params?.data?.od?.split(" ");
    // console.log(words);
    let current;
    if (words) {
      current = words[0].length;
    } else {
      current = 0;
      words = [];
    }
    // console.log({ current });
    while (current > 35) {
      newlines += 1;
      current = current - 35;
    }
    for (let i = 1; i < words.length; i++) {
      let test = current + words[i].length + 1;
      if (test > 35) {
        newlines += 1;
        current = words[i].length;
        while (current > 35) {
          newlines += 1;
          current = current - 35;
        }
      } else {
        current = test;
      }
    }
    // console.log(27 + newlines * 17, "final value");
    // // One line needs 27px, with a line-height of 1.5, every additional line needs 17px.
    return 27 + newlines * 8;
  };

  let firstButtonPart = <Grid columns="equal" centered className="fixWidthBloc3">
    <Grid.Row>
      <Button.Group className="marginBottomClass">
        <NOTE1COLUMN_MOTIF_CS
          ID={ID}
          syncData={syncData}
          option={7}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE1COLUMN_AV_SC
          ID={ID}
          syncData={syncData}
          option={8}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE1COLUMN_CO_PORTEE
          ID={ID}
          syncData={syncData}
          option={8}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE1COLUMN_CO_PORTEE_FINALE
          ID={ID}
          syncData={syncData}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE1COLUMN_PIO
          ID={ID}
          syncData={syncData}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE3COLUMNS_LAF
          ID={ID}
          syncData={syncData}
          option={6}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE3COLUMNS_FO
          ID={ID}
          syncData={syncData}
          option={5}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE3COLUMNS_ANGIO
          ID={ID}
          syncData={syncData}
          option={4}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE3COLUMNS_OCT
          ID={ID}
          syncData={syncData}
          option={3}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE3COLUMNS_ACTE_REALISE
          ID={ID}
          syncData={syncData}
          option={1}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <NOTE3COLUMNS_ACTE_PROPOSE
          ID={ID}
          syncData={syncData}
          option={2}
          AuthState={AuthState}
        />
      </Button.Group>
      <Button.Group className="marginLeftClass">
        <Note syncData={syncData} />
      </Button.Group>

      {PatientelleState?.id_Magica ? (
        <>
          <Button.Group className="marginLeftClass">
            <Migration syncData={syncData} option={9} />
          </Button.Group>
        </>
      ) : null}
    </Grid.Row>
  </Grid>

  let historicMagica = PatientelleState?.id_Magica ? (
    <>
      <Button.Group className="marginLeftClass">
        <Migration syncData={syncData} option={9} />
      </Button.Group>
    </>
  ) : null;

  let bouttonsOrdonnances = <>
    <Button.Group className="marginLeftClass">
      <Medicaments
        ID={ID}
        syncData={syncData}
        option={15}
        userInformation={userInformation}
        AuthState={AuthState}
      />
      <MedicamentsHistoric
        ID={ID}
        syncData={syncData}
        option={15}
        userInformation={userInformation}
        AuthState={AuthState}
      />
    </Button.Group>
    <Button.Group className="marginLeftClass">
      <ModalPDF ID={ID} syncData={syncData} AuthState={AuthState} />
    </Button.Group>
    <Button.Group className="marginLeftClass">
      <NewExamensComplementaire
        ID={ID}
        syncData={syncData}
        option={9}
        userInformation={userInformation}
        AuthState={AuthState}
      />
      <HistoricNewExamensComplementaire
        ID={ID}
        syncData={syncData}
        option={9}
        userInformation={userInformation}
        AuthState={AuthState}
      />
    </Button.Group>
    <Button.Group className="marginLeftClass">
      <Courrier2
        ID={ID}
        syncData={syncData}
        option={9}
        userInformation={userInformation}
        questionnaireData={questionnaireData}
        consultationData={state.rowData}
        AuthState={AuthState}
      />
      <CourrierHistoric
        ID={ID}
        syncData={syncData}
        option={15}
        userInformation={userInformation}
        AuthState={AuthState}
      />
    </Button.Group>
    <Button.Group className="marginLeftClass">
      <Cert
        ID={ID}
        syncData={syncData}
        option={9}
        userInformation={userInformation}
        questionnaireData={questionnaireData}
        consultationData={state.rowData}
        AuthState={AuthState}
      />

      <CertHistoric
        ID={ID}
        syncData={syncData}
        option={15}
        userInformation={userInformation}
        AuthState={AuthState}
      />

    </Button.Group>
  </>

  let deletebtn = ""


  if (width >= 717 && state.id_consultation) {
    deletebtn = <Button
      style={{ position: "absolute", right: "0.6rem" }}
      icon
      color="red"
      onClick={() => deleteOneExamen()}
      floated="right"
    >
      {state.nom_examen}
      <Icon name="trash" size='large' />
    </Button>
  } else if (width >= 717 && !state.id_consultation) {
    deletebtn = <Button
      style={{ position: "absolute", right: "0.6rem" }}
      icon
      color="red"
      floated="right">
      <Icon name="trash" size='large' />
    </Button>
  } else {
    deletebtn = ""
  }

  let myComponent = <Button.Group className="DisplayFlexGALAXYFOLD" >
    <NOTE1COLUMN_MOTIF_CS
      ID={ID}
      syncData={syncData}
      option={7}
      AuthState={AuthState}
    />
    <NOTE3COLUMNS_ACTE_REALISE
      ID={ID}
      syncData={syncData}
      option={1}
      AuthState={AuthState}
    />
    <NOTE3COLUMNS_ACTE_PROPOSE
      ID={ID}
      syncData={syncData}
      option={2}
      AuthState={AuthState}
    />
    <Note syncData={syncData} />
  </Button.Group>

  let resultToshow = ""

  if (width > 665 && width < 1023) {
    resultToshow = myComponent
  }


  return (
    <>
      {width >= 1023 ? firstButtonPart : historicMagica}
      {resultToshow}

      <div
        id="myGrid"
        className="ag-theme-balham"
        // className="ag-theme-alpine"
        style={{
          height: NewHeightValue,
          // height: "91vh",
          width: "100%",
          // paddingTop: "0.2rem",
          paddingBottom: "0.2rem",
        }}
      >
        <AgGridReact
          getRowHeight={myfunc}
          rowData={state.rowData}
          // animateRows={true}
          sortingOrder={["desc", "asc", null]}
          onGridReady={onGridReady}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowSelection={"single"}
          onSelectionChanged={onSelectionChanged}
          undoRedoCellEditing={true}
          undoRedoCellEditingLimit={40}
          onCellValueChanged={onCellValueChanged}
        ></AgGridReact>
      </div>
      {width >= 717 ? bouttonsOrdonnances : null}
      {deletebtn}
    </>
  );
}

export default Bloc3;
